import './App.css';
import NotFound from './NotFound';
import Recruit from './Components/Recruit/Index';
import RecruitNews from './Components/RecruitNews/Index';
import RecruitLine from './Components/RecruitLine/Index';
import RecruitEarnings from './Components/RecruitEarnings/Index';
import PersonalGoals from './Components/PersonalGoals/Index';
import Introduction from './Components/Introduction/Index';
import StampCard from './Components/StampCard/Index';
import StampPut from './Components/StampPut/Index';
import Header from './Components/Layout/HeaderComponents';
import Left from './Components/Layout/LeftComponents';
import TrainingEventList from './Components/TrainingEventList/Index';
import ReservationCall from './Components/ReservationCall/Index';
import Approval from './Components/WorkFlow/ApprovalIndex';
import Application from './Components/WorkFlow/ApplicationIndex';
import NewApplication from './Components/WorkFlow/NewApplication';
import ReApplication from './Components/WorkFlow/ReApplication';

import { Routes, Route } from 'react-router-dom';
// import Recruit from './Components/Recruit/Index';
// import { Route } from 'react-router';
// import '/Components/Recruit/Css/GeneralAffairsData.css';
import React from 'react';
const authentication = require('./react-azure-adb2c2').default;
export const Authentication = React.createContext()
class App extends React.Component {
render() {
  console.log(this.state)
  return (
    
      <div className="App">
        <Authentication.Provider value={authentication}>
        <Header/>
        <Left className="Left" width={60}/>
        <Routes >
          <Route exact path="/" element={<StampCard />} />
          <Route path="/RecruitNews" element={<RecruitNews />} />
          <Route path="/RecruitLine" element={<RecruitLine />} />
          <Route path="/RecruitEarnings" element={<RecruitEarnings />} />
          <Route path="/PersonalGoals" element={<PersonalGoals />} />
          <Route path="/Introduction" element={<Introduction />} />
          <Route path="/StampCard" element={<StampCard />} />
          <Route path="/TrainingEventList" element={<TrainingEventList />} />
          <Route path="/StampPut" element={<StampPut />} />
          <Route path="/ReservationCall" element={<ReservationCall />} />
          <Route path="/Approval" element={<Approval />} />
          <Route path="/Application" element={<Application />} />
          <Route path='/NewApplication/:id' element={<NewApplication />} />
          <Route path='/ReApplication/:id' element={<ReApplication />} />
          <Route path={`/*/`} element={<NotFound />} />

        </Routes>
        </Authentication.Provider>
        <style jsx="true">{
        `
        
        #content {
          width:calc(100% - 60px);
          padding:80px 0 0 60px;
          height: calc(100% - 50px);
          // overflow: auto;
        }
        @media screen and (max-width: 768px) {
          .Left{
            display:none;
          }
          #content {
            width:100%;
            padding:80px 0 0 0px;
            height: calc(100% - 50px);
            // overflow: auto;
          }
        }

        `
      }
      </style>
      </div>
    )
    };
};

export default App;
